export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.87 13.96c.06-.21.32-1.17-.29-2.56-1.259-2.896-.186-3.954.546-4.676.39-.384.683-.673.474-1.094-.4-.79-1.46-3.36 1.34-4.46 1.8-.7 2.78.92 3.14 1.7.38-.08.78-.14 1.24-.14 5.41 0 4.65 6.07 4.64 6.11 0 0-.56 5.16-4.64 5.16-3.14 0-4.22-3.27-4.52-4.6-.18.38-.33 1.06-.25 2.27.09 1.26-.87 2.29-1.65 2.33-.02 0-.04-.02-.03-.04zM8.46 16h7.08C18 16 20 17.97 20 20.39v1.91c0 .39-.32.7-.71.7H4.71c-.39 0-.71-.31-.71-.7v-1.91C4 17.97 6 16 8.46 16z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 24 24"
  }
};